import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreIputWithValidationComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-input-with-validation/mapfre-input-with-validation.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Location } from '@angular/common';
import { Component, OnInit , NO_ERRORS_SCHEMA } from '@angular/core';
import { FormGroup , FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Router , RouterModule } from '@angular/router';
import {
  AcmicService,
  FormBaseControlService,
} from '@mapfre-design-library/src/public_api';
import { AuthenticationService } from '../../../../_services/_iam/authentication-service.service';
import { ErrorRedirectionService } from '../../../../_services/error-service/error-redirection.service';
import { CreateAccountService } from '../../../../_services/forms/create-account/create-account-service.service';
import { ValidateEmailService } from '../../../../_services/signup-process-service/validate-email.service';
import { UserService } from '../../../../_services/user.service';

@Component({
  standalone: true,
  schemas: [NO_ERRORS_SCHEMA],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreIputWithValidationComponent, MapfreButtonComponent],
  selector: 'app-account-activate-for-legacy',
  templateUrl: './account-activate-for-legacy.component.html',
  styleUrls: ['./account-activate-for-legacy.component.scss'],
})
export class AccountActivateForLegacyComponent implements OnInit {
  inputs: any[];
  activateEmailForm: FormGroup;
  userData: any;
  isAcmic = false;

  constructor(
    private service: CreateAccountService,
    private ipt: FormBaseControlService,
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private validateEmailService: ValidateEmailService,
    private isAcmicService: AcmicService,
    private errorRedirectionService: ErrorRedirectionService,
    private location: Location
  ) {
    this.inputs = service.getconfirmEmailInputs();
  }

  ngOnInit(): void {
    this.activateEmailForm = this.ipt.toFormGroup(this.inputs);
    this.userData = this.userService.getUserInfoInStorage();
    this.isAcmic = this.isAcmicService.isACMIC();
  }

  activeEmail() {
    const newEmail = this.activateEmailForm
      .get('createAc_email')
      .value.trim()
      .toLowerCase();
    this.userData.userDetails['newEmail'] = newEmail;
    this.userService.placeUserInfoInStorage(this.userData);
    this.userService.setCommercialAcFlag(false);
    this.userService.updateUser(this.userData);
    this.authenticationService.verifyForUserExists(newEmail).subscribe(
      (resp) => {
        if (resp) {
          this.router.navigate(['signup', 'account-exists']);
        } else {
          this.triggerSendValidationEmail(newEmail);
        }
      },
      () => {
        this.triggerSendValidationEmail(newEmail);
      }
    );
  }

  triggerSendValidationEmail(newEmail) {
    this.validateEmailService
      .sendValidationEmailForNonCommercial(newEmail, false, false)
      .subscribe(
        () => {
          this.userData.userDetails['isEmailEntered'] = true;
          this.userService.placeUserInfoInStorage(this.userData);
          this.router.navigate(['/signup', 'validate-account']);
        },
        (error) => {
          this.errorRedirectionService.errorHandler(
            error,
            'VERIFICATION_EMAIL_ERROR'
          );
        }
      );
  }
  goBack() {
    this.location.back();
  }
}
